
import { mapActions, mapState, mapGetters } from 'vuex';

import ProductTags from '@/components/catalog/productTags';
import Button from '@/components/elements/Button';
import CustomImage from '~/components/elements/CustomImage';

export default {
  name: 'ProductBundle',

  components: {
    CustomImage,
    ProductTags,
    Button,
  },

  props: {
    bundle: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters('currency', { getCurrency: 'getCurrency' }),
    ...mapState('route', {
      categoryCode: (state) => state.params.category,
      productCode: (state) => state.params.product,
    }),

    ...mapGetters('cart', [
      'productInCart',
      'getProductCountWithBundle',
    ]),

    mqIsMobile() {
      return this.$mq === 'mobileXs' || this.$mq === 'mobile' || this.$mq === 'tablet' || this.$mq === 'laptop';
    },

    totalTags() {
      if (this.bundle.oldPrice.value) {
        const benefit = this.bundle.oldPrice.value - this.bundle.price.value;

        return benefit > 0 ? [`Выгода ${this.getCurrency(benefit)}`] : [];
      }

      return [];
    },

    firstProducts() {
      return this.bundle.items?.length > 1 ?
        [this.bundle.items[0], this.bundle.items[1]] :
        [];
    },

    bundleInCart() {
      return this.productInCart(this.bundle.id);
    },

    isMax() {
      const someProductCountIsMax = this.bundle.items.some(product => {
        return this.getProductCountWithBundle(product.id) >= product.stock.qty;
      });

      return this.bundleInCart || someProductCountIsMax;
    },

    inCartText() {
      return this.bundleInCart ? 'Добавлен в корзину' : 'В корзину комплектом';
    },
  },

  methods: {
    ...mapActions('cart', [
      'addToCartProduct',
    ]),

    isCurrentProduct(product) {
      return product.code === this.productCode &&
             product.categoryCodes.includes(this.categoryCode);
    },

    getLinkTag(product) {
      return this.isCurrentProduct(product) ? 'div' : 'nuxt-link';
    },

    getCategoryLink(categoryCodes) {
      return categoryCodes?.length > 0 && categoryCodes[categoryCodes.length - 1];
    },

    getProductProps(product) {
      if (!this.isCurrentProduct(product)) {
        return {
          to: {
            name: 'catalog.category.product',
            params: {
              category: this.getCategoryLink(product.categoryCodes),
              product: product.code,
            },
          },
        };
      }

      return false;
    },

    getImage(product) {
      if (product.image) {
        return product.image.url;
      } else if (Array.isArray(product.media) && product.media.length > 0) {
        return product.media[0].url
      }

      return '';
    },

    onAddCartButtonClick() {
      this.addToCartProduct({
        ...this.bundle,
        type: 'bundle_product',
      });
    },
  },
}
